import { useContext } from 'react'
import { Dropdown, Toast } from 'antd-mobile'
import { GlobalContext } from '@/context'
import localeSwitch from '@/locale/localeSwitch'
import { Language } from '@/utils/language'
import { setCookie } from 'cookies-next'
import styles from './index.module.less'
import { COOKIE_EXPIRE_TIME, LANG_COOKIE } from '@/utils/constants'
import { IProps, langOptions } from '@/components/LanguageSwitch'

const MobileLangSwitch = ({ theme = 'dark' }: IProps) => {
  const { lang } = useContext(GlobalContext)

  const handleClick = (value: Language) => {
    setCookie(LANG_COOKIE, value, { maxAge: COOKIE_EXPIRE_TIME })

    const nextLang = localeSwitch[value]
    const curLabel = langOptions.find((item) => item.value === value)?.label
    Toast.show({
      content: `${nextLang['message.lang.tips']}${curLabel}`
    })
    window.location.reload()
  }

  return (
    <div>
      <Dropdown closeOnClickAway>
        <Dropdown.Item key="lang" title={langOptions.find((item) => item.value === lang)?.label}>
          <div className={styles['select-list']}>
            {langOptions.map((item, index) => {
              return (
                <div key={index} className={styles['select-item']} onClick={() => handleClick(item.value)}>
                  {item.label}
                </div>
              )
            })}
          </div>
        </Dropdown.Item>
      </Dropdown>
    </div>
  )
}

export default MobileLangSwitch
